import { gql } from "@urql/core";

import { query } from "@/services/lukita";

export default function projectQuery({ slug, accountId, requestOptions = {} }) {
  return query(
    gql`
      query ProjectQuery($slug: String!, $accountId: ID!) {
        project(slug: $slug, accountId: $accountId) {
          __typename
          id
          slug
          name
          status
          isLocationsEnabled: hasFeature(name: "transactions_locations")
          isPromptEnabled: hasFeature(name: "project_prompt")
          promptReport
          promptStatus
          promptHistory
          createdAt
        }
      }
    `,
    {
      slug,
      accountId,
    },
    {
      additionalTypenames: ["StatementRecord", "ProjectRecord"],
      ...requestOptions,
    },
  );
}
